const RETURN_KEY = 'siesta-outlook-oauth-return';

type OutlookOAuthReturn = {
  path: string;
  conversationId: string;
};

export function storeOutlookOAuthReturn(value: OutlookOAuthReturn) {
  sessionStorage.setItem(RETURN_KEY, JSON.stringify(value));
}

export function peekOutlookOAuthReturn(): OutlookOAuthReturn | null {
  const raw = sessionStorage.getItem(RETURN_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as OutlookOAuthReturn;
    return typeof parsed.path === 'string' && typeof parsed.conversationId === 'string'
      ? parsed
      : null;
  } catch {
    return null;
  }
}

export function consumeOutlookOAuthReturn(): OutlookOAuthReturn | null {
  const value = peekOutlookOAuthReturn();
  sessionStorage.removeItem(RETURN_KEY);
  return value;
}
